// Manager-bucket AI prompting suggestions awaiting review — §5.2 / SC-5.
//
// Open `ai_prompt_suggestions` rows (`status=open`) via `listSuggestions`.
// R3: renders `null` when count is zero or unknown.

import type { PrimaryMode } from "@/components/lead/sections/LeadWorkspaceHeaderAccess";
import { formatAiPromptingSuggestionsBodyLine } from "./managerDockCopy";

export type ActivityDockAiPromptingSuggestionsSectionProps = {
  aiPromptingOpenCount: number | null;
  currentMode?: PrimaryMode | null;
  onOpenAiPrompting?: () => void;
};

export function ActivityDockAiPromptingSuggestionsSection({
  aiPromptingOpenCount,
  currentMode = null,
  onOpenAiPrompting,
}: ActivityDockAiPromptingSuggestionsSectionProps) {
  if (aiPromptingOpenCount == null || aiPromptingOpenCount <= 0) return null;

  const bodyLine = formatAiPromptingSuggestionsBodyLine(
    aiPromptingOpenCount,
    currentMode,
  );

  return (
    <section
      aria-label="AI prompting suggestions reminder"
      className="mt-3 rounded-2xl border border-indigo-300 bg-indigo-50 px-3 py-3 text-left text-xs text-indigo-900 dark:border-indigo-700 dark:bg-indigo-950/35 dark:text-indigo-100"
    >
      <div className="flex items-center justify-between gap-2">
        <div className="min-w-0">
          <div className="text-[11px] font-semibold uppercase tracking-wide opacity-80">
            Prompt suggestions
          </div>
          <p className="mt-1 text-[12px] leading-snug">{bodyLine}</p>
        </div>
        {onOpenAiPrompting ? (
          <button
            type="button"
            onClick={onOpenAiPrompting}
            className="shrink-0 rounded-lg bg-indigo-700 px-2.5 py-1.5 text-[11px] font-semibold text-white hover:bg-indigo-800 dark:bg-indigo-600 dark:hover:bg-indigo-500"
          >
            Review
          </button>
        ) : null}
      </div>
    </section>
  );
}
